import {
  Area,
  CartesianGrid,
  ComposedChart,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import type { DrawdownHistoryPointDto } from '../../lib/api/endpoints';

interface DrawdownChartProps {
  history: DrawdownHistoryPointDto[] | undefined;
}

export function DrawdownChart({ history }: DrawdownChartProps) {
  const data = (history ?? []).map((point) => ({
    date: point.date,
    nav: Number(point.nav),
    peakNav: Number(point.peakNav),
    drawdownBand: Math.max(0, Number(point.peakNav) - Number(point.nav)),
  }));

  return (
    <div className="rounded border border-border bg-surface p-4">
      <h2 className="text-lg font-semibold">NAV vs Peak NAV</h2>
      {data.length === 0 ? (
        <p className="mt-4 text-sm text-text-muted">No NAV history for this range.</p>
      ) : (
        <div
          className="mt-4 h-72"
          role="img"
          aria-label={`NAV and peak NAV chart with ${data.length} points showing current drawdown versus trailing peak.`}
        >
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart data={data} margin={{ left: 0, right: 8, top: 8, bottom: 0 }}>
              <CartesianGrid stroke="#2A3142" vertical={false} />
              <XAxis dataKey="date" stroke="#A1A8B8" tick={{ fontSize: 12 }} />
              <YAxis stroke="#A1A8B8" tick={{ fontSize: 12 }} width={64} />
              <Tooltip
                contentStyle={{
                  background: '#222837',
                  border: '1px solid #2A3142',
                  color: '#E6E9EF',
                }}
              />
              <Legend />
              <Area
                dataKey="drawdownBand"
                name="Drawdown"
                fill="#3A0E0E"
                stroke="transparent"
                isAnimationActive={false}
              />
              <Line dataKey="nav" name="NAV" stroke="#10B981" strokeWidth={2} dot={false} />
              <Line
                dataKey="peakNav"
                name="Peak NAV"
                stroke="#A1A8B8"
                strokeDasharray="6 4"
                strokeWidth={2}
                dot={false}
              />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
}
